/**
 * Ruleset registry.
 *
 * Adding Riichi later means implementing the `Ruleset` interface in
 * `src/rules/riichi/` and adding one line here. Nothing else changes.
 *
 * `mcr` is registered (so it's reachable via `getRuleset('mcr')` and fully
 * testable) but NOT yet wired into the player-facing UI — see the module
 * header on `./mcr` for why: Phase 1 only, no pattern detection, every hand
 * currently scores 0.
 */

import { hkos } from './hkos';
import { mcr } from './mcr';
import type { Ruleset } from './types';

export * from './tiles';
export * from './types';
export { hkos } from './hkos';
export { mcr } from './mcr';

export const RULESETS: Record<string, Ruleset<any>> = {
  [hkos.id]: hkos,
  [mcr.id]: mcr,
};

export function getRuleset(id: string): Ruleset<any> {
  const r = RULESETS[id];
  if (!r) throw new Error(`Unknown ruleset "${id}". Known: ${Object.keys(RULESETS).join(', ')}`);
  return r;
}
